import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../widgets/form/InputDateUI'

const ClientWiseSummaryDownloadModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  downloadMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  startDate, onStartDateChange, startDateError, setStartDateError,
  endDate, onEndDateChange, endDateError, setEndDateError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Download client-wise summary'
    buttonLabel='Download'
    cancelLabel='Cancel'
    isOpen={downloadMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputDateUI context={context} name='date' label='Start date'
      selectedDateISO={startDate} onChange={onStartDateChange}
      error={startDateError} setError={setStartDateError}
      required={true}
    />
    <InputDateUI context={context} name='date' label='End date'
      selectedDateISO={endDate} onChange={onEndDateChange}
      error={endDateError} setError={setEndDateError}
      required={true}
    />
  </ModalFormUI>

export default ClientWiseSummaryDownloadModalUI
